import { AccountFragment } from 'src/graphql'

const hasExpenseBucket = (account: AccountFragment): boolean =>
  !!account.expenseReload

export default hasExpenseBucket
